const CREDIT_USE = 'CREDIT_USE';
const CREDIT_FILL = 'CREDIT_FILL';

const CreditSymbols = {
  CREDIT_USE,
  CREDIT_FILL
};

export default CreditSymbols;
